import React from 'react'
import { RetailCategory } from './types'
import { Text } from '@hub/text'
import { useStoresRoute } from './use-stores-route'
import {
  Navigation,
  NavigationButton,
  NavigationLink,
  NavigationPanel,
  NavigationPanelBackButton,
  NavigationPanelBody,
  NavigationPanelCloseButton,
  NavigationPanelHeader,
  NavigationPanelMenu,
} from '@hub/navigation'
import { H4 } from '@hub/heading'
import { useIsRouteChanging } from '@scentregroup/shared/next/router'

type CategoriesNavProps = React.PropsWithChildren<{
  open: boolean
  categories: RetailCategory[]
  containerRef: React.RefObject<HTMLElement | null>
  onClose: () => void
}>

export const CategoriesNav: React.FC<CategoriesNavProps> = ({
  open,
  categories,
  containerRef,
  onClose,
}) => {
  const isRouteChanging = useIsRouteChanging()
  const linkToCategory = useStoresRoute()
  return (
    <Navigation
      containerRef={containerRef}
      placement="left"
      allowOpen={!isRouteChanging}
      onClose={onClose}
      backgroundColor="surfaceBrandPrimary"
    >
      <NavigationPanel isOpen={open}>
        <NavigationPanelHeader>
          <NavigationPanelCloseButton />
        </NavigationPanelHeader>
        <NavigationPanelBody>
          <H4 as={Text}>All categories</H4>
          <NavigationLink href={linkToCategory([])}>All stores</NavigationLink>
          {categories.map((category, key) => {
            if ((category.children?.length ?? 0) > 0) {
              return (
                <NavigationPanelMenu key={key}>
                  <NavigationButton>{category.title}</NavigationButton>
                  <NavigationPanel>
                    <NavigationPanelHeader>
                      <NavigationPanelCloseButton isMobileOnly />
                      <NavigationPanelBackButton isMobileOnly />
                    </NavigationPanelHeader>
                    <NavigationPanelBody>
                      <H4 as={Text}>{category.title}</H4>
                      <Text>Choose a subcategory</Text>
                      {category.children?.map((subCategory, key) => (
                        <NavigationLink
                          key={key}
                          href={linkToCategory([
                            category.slug,
                            subCategory.slug,
                          ])}
                        >
                          {subCategory.title}
                        </NavigationLink>
                      ))}
                    </NavigationPanelBody>
                  </NavigationPanel>
                </NavigationPanelMenu>
              )
            } else {
              return (
                <NavigationLink
                  key={key}
                  href={linkToCategory([category.slug])}
                >
                  {category.title}
                </NavigationLink>
              )
            }
          })}
        </NavigationPanelBody>
      </NavigationPanel>
    </Navigation>
  )
}
